module.exports = __webpack_public_path__ + "static/media/passportservice.5a31bec9.png";